export const widths = {
  tablet: 550,
  desktop: 1024,
};
